export const offers = {
  list_title: "Promotions",
  list_cta: "Create promotion",
  list_empty_title: "You don't have promotions yet",
  list_empty_description: "Create your first promotion to attract more customers with discounts on products or categories.",
  search_placeholder: "Search promotion",
  reload: "Reload",
  filters: {
    active: "Active",
    expired: "Expired",
    scheduled: "Scheduled",
    disabled: "Disabled",
  },
  status: {
    active: "Active",
    expired: "Expired",
    scheduled: "Scheduled",
    disabled: "Disabled",
  },
  card: {
    products: "{{count}} products",
    categories: "{{count}} categories",
    all_products: "All products",
    all_categories: "All categories",
    discount: "Discount",
    always_available: "Always available",
    valid_from: "From {{date}}",
    valid_until: "Until {{date}}",
    valid_range: "{{start}} - {{end}}",
  },
  delete_modal: {
    title: "Delete promotion",
    description: "Are you sure you want to delete this promotion? This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  expired_modal: {
    title: "Expired promotion",
    description: "This promotion has expired. You can edit it to extend the dates or delete it.",
    edit: "Edit",
    delete: "Delete",
  },
  wizard: {
    title_create: "Create promotion",
    title_edit: "Edit promotion",
    steps: {
      selector: "Products",
      discount: "Discount",
      form: "Information",
    },
    back: "Back",
    continue: "Continue",
    save: "Save promotion",
    create: "Create promotion",
  },
  selector: {
    products_tab: "Products",
    categories_tab: "Categories",
    search_products: "Search product",
    search_categories: "Search category",
    select_all: "Select all",
    no_products: "You have no available products",
    no_categories: "You have no available categories",
    products_count: "{{count}} products",
    product_status: {
      inactive: "Inactive",
      sold_out: "Sold out",
      active_offer: "In another offer",
    },
  },
  discount: {
    mode_bulk: "Bulk discount",
    mode_individual: "Individual discount",
    type_percentage: "Percentage",
    type_value: "Fixed value",
    bulk_label: "Discount for all",
    price_with_discount: "Price with discount",
  },
  form: {
    name: "Promotion name",
    name_placeholder: "E.g. Summer sale",
    description: "Description",
    description_placeholder: "Describe your promotion",
    schedule_dates: "Schedule dates",
    start_date: "Start date",
    end_date: "End date",
    products_section: "Included products",
    categories_section: "Included categories",
  },
  detail: {
    title: "Promotion details",
    edit: "Edit",
    discount_type: "Discount type",
    dates: "Dates",
    no_dates: "No scheduled dates",
    products: "Products",
    categories: "Categories",
  },
  messages: {
    created: "Promotion created successfully",
    updated: "Promotion updated successfully",
    deleted: "Promotion deleted",
    error_save: "Could not save promotion",
    error_delete: "Could not delete promotion",
    error_load: "Could not load promotions",
    validation_name: "Name is required",
    validation_discount: "Please check the discounts entered",
    validation_selection: "Select at least one product or category",
  },
};
